import { useState, useEffect, useRef, useLayoutEffect, useMemo } from 'react'
import { useSpring } from '@react-spring/web'
import styled from 'styled-components'
import Spinner from '../Spinner'
import { device } from '../breakpoints'

export const CanvasVideoPlayerB = ({
  progress,
  onMounted,
  onLoaded,
  started,
}: {
  progress: number
  onMounted: (boundingClientRect: DOMRect | undefined) => void
  onLoaded: () => void
  started: boolean
}) => {
  const isMobile = window.innerWidth < 768
  const [video, setVideo] = useState<HTMLVideoElement | null>()
  const [seeking, setSeeking] = useState<boolean>(false)
  const [loadedImagesCount, setLoadedImagesCount] = useState<number>(0)
  const frameCount = 550 // 170
  const currentFrame = useRef(0)
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 })
  const context = useRef<CanvasRenderingContext2D | null>()
  const isLoading = loadedImagesCount < frameCount
  const hwRatio = 1121 / 2000
  const whRatio = 2000 / 1121
  const orientation =
    dimensions.width * hwRatio > dimensions.height ? 'landscape' : 'portrait'
  const imageWidth =
    orientation === 'landscape'
      ? dimensions.width * 2
      : dimensions.height * 2 * whRatio
  const imageHeight =
    orientation === 'landscape'
      ? dimensions.width * 2 * hwRatio
      : dimensions.height * 2

  useSpring(
    () => ({
      pct: progress,
      config: { duration: 1000 },
      onChange: (e) => {
        const pct = e.value.pct
        const frame = Math.floor(pct * (frameCount - 1))
        const lastFrame = currentFrame.current

        // const a = document.getElementById('debug-frame')
        // if (a) {
        //   a.innerHTML = `${frame}`
        // }

        if (lastFrame !== frame && video) {
          // console.log('frame', frame, 'current time: ', frame / 30)

          if (!seeking) {
            video.currentTime = frame / 30
            // video.pause()
          }
        }

        currentFrame.current = frame
      },
    }),
    [progress, seeking]
  )

  // Set the new dimensions state when the window is resized
  const resize = () => {
    setDimensions({ width: window.innerWidth, height: window.innerHeight })
  }

  // Preload the images for the animation
  useMemo(() => {}, [])

  // Preload the images and set the dimensions when the component mounts
  useEffect(() => {
    resize()

    // setup resize event
    window.addEventListener('resize', resize)

    return () => {
      window.removeEventListener('resize', resize)
    }
  }, [])

  useEffect(() => {}, [dimensions])

  useEffect(() => {
    // console.log('Loading?', isLoading)
    !isLoading && onLoaded()
  }, [isLoading])

  useEffect(() => {}, [started])

  return (
    <>
      <Video
        width={dimensions.width}
        height={dimensions.height}
        ref={setVideo}
        preload='auto'
        // poster=''
        playsInline
        autoPlay
        src={require(`./${isMobile ? 'mobile' : 'desktop'}.mp4`)}
        onSeeking={(e) => {
          setSeeking(true)
        }}
        onSeeked={(e) => {
          setSeeking(false)
        }}
        onPlay={(e) => {
          video?.pause()
        }}
      />
    </>
  )
}

const Video = styled.video`
  height: 100vh;
  left: 0;
  object-fit: cover;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 0;
`

export default CanvasVideoPlayerB
